import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { DailyStats } from './dashboard.types'

/** Polling du dashboard : 30s (le cache Redis côté API tient 25s). */
export const DAILY_STATS_POLL_MS = 30_000

/**
 * Récupère les KPI du jour. `refetchInterval` 30s → mise à jour des cartes sans
 * rechargement ; `placeholderData` garde les valeurs précédentes pour éviter le
 * retour au skeleton à chaque poll.
 */
export function useDailyStats() {
  return useQuery<DailyStats>({
    queryKey: ['admin', 'stats', 'daily'],
    queryFn: async () => {
      const { data } = await api.get<DailyStats>('/admin/stats/daily')
      return data
    },
    refetchInterval: DAILY_STATS_POLL_MS,
    placeholderData: (prev) => prev,
    staleTime: 30_000,
  })
}
